import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Tag, TagId } from '@portal-front-end/models';

@Injectable({ providedIn: 'root' })

export class TagsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly TAG_URL = `${this.apiServer}/tag`;

    getTags(): Observable<Tag[]> {
        return this.http.get<Tag[]>(this.TAG_URL);
    }
}
